<template>
	<div class="forgetPassword">
		<v-stepper v-model="step">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
        	<v-card class="py-8 px-10 text-center">
            <h3 class="mb-2">忘記密碼?</h3>
            <v-icon>fa-key</v-icon>
            <!-- <div>輸入您的電子郵件</div>
            <div>我們將傳送重置密碼的連結給您</div> -->
            <!-- <span class="d-block text-left mt-4">Email</span>
            <v-text-field outlined dense v-model="email" :rules="[$rules.email]" @keydown.enter="sendResetMail"></v-text-field>
            <v-btn dark rounded block height="40" color="pink" class="mt-6" @click="sendResetMail">下一步</v-btn> -->
            <div>輸入您的手機號碼</div>
            <div>我們將傳送驗證碼給您</div>
            <span class="d-block text-left mt-4">手機號碼</span>
            <v-text-field outlined dense v-model="tel" :rules="[$rules.integer]" @keydown.enter="sendResetMail"></v-text-field>
            <v-btn dark rounded block height="40" color="pink" class="mt-6" @click="sendResetMail">下一步</v-btn>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="pa-0">
          <!-- <v-card class="py-8 px-10 verify">
            <h3 class="mb-6">檢查您的信箱來重置密碼</h3>
            <div>我們已經送出一封信件到您的 Email</div>
            <div class="font-weight-bold">{{ email }}</div>
            <div>請檢查您的Email以重置密碼</div>
            <v-icon color="indigo">fa-envelope-open-text</v-icon>
            <div>沒有收到信件 ?</div>
            <a @click="sendResetMail" v-if="!sending">重新發送信件</a>
            <div v-if="sending">{{ time }}</div>
            <h3 class="mb-6">檢查您的信箱來重置密碼</h3>
            <div>我們已經送出一封信件到您的 Email</div>
            <div class="font-weight-bold">{{ email }}</div>
            <div>請檢查您的Email以重置密碼</div>
            <v-icon color="indigo">fa-envelope-open-text</v-icon>
            <div>沒有收到信件 ?</div>
            <a @click="sendResetMail" v-if="!sending">重新發送信件</a>
            <div v-if="sending">{{ time }}</div>
          </v-card> -->
          <v-card class="py-8 px-10 verify">
            <h3 class="mb-6 text-center">手機驗證</h3>
            <div class="d-flex align-center mb-6">
              <v-icon class="mr-4">fa-phone-alt</v-icon>
              <div>請輸入 <span class="font-weight-bold">{{ tel }}</span> 收到的6位數驗證碼，驗證碼15分鐘內有效</div>
            </div>
            <span>手機驗證碼</span>
            <div class="code-input">
              <div v-for="(n, i) in 6">
                <input 
                  :ref="`input${i}`" 
                  type="number"
                  @keydown="inputAction(i)" 
                  v-model="code[i]"
                >
              </div>
            </div>
            <a @click="!sending ? sendResetMail() : ''" :class="['resend', {'not-allow': sending}]">
              <span :class="sending ? 'grey-1--text' : 'pink--text'">重新發送驗證碼 </span>
              <span v-if="sending">({{ time }})</span>
              <v-icon v-else x-small color="pink" class="pl-2">fa-chevron-right</v-icon>
            </a>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3" class="pa-0">
          <v-card class="py-8 px-10">
            <h3 class="mb-2 text-center">重置密碼</h3>
            <v-icon class="d-block text-center">fa-lock</v-icon>
            <span>新密碼</span>
            <v-tooltip bottom nudge-right="105">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-2 my-0" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
              </template>
              <span>密碼長度須為 6 到 10 個字，且包含英文字母及數字</span>
            </v-tooltip>
            <v-text-field outlined dense type="password" v-model="password" :rules="[$rules.password]"></v-text-field>
            <span class="d-block text-left">確認新密碼</span>
            <v-text-field outlined dense type="password" v-model="rePassword" :rules="[rules.rePassword]" @keydown.enter="resetPassword"></v-text-field>
            <v-btn dark rounded block height="40" color="pink" class="mt-2" @click="resetPassword">送出</v-btn>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4" class="pa-0">
          <v-card class="py-8 px-10 text-center">
            <h3 class="mb-2">重置密碼成功</h3>
            <v-icon color="green">fa-check</v-icon>
            <div>您已成功重置密碼</div>
            <div>祝您購物惀快</div>
            <v-btn block rounded class="mt-6" color="pink" to="/">開始購物</v-btn>
          </v-card>
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data() {
		return {
			step: 1,
      email: '',
      tel: '',
      sending: false,
      time: 120,
      code: Array(6).fill(''),
      password: '',
      rePassword: '',
      rules: {
        rePassword: value => this.password == value
      }
		}
	},
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['all_verified'])
  },
  methods: {
    input(i) {
      return this.$refs[`input${i}`][0]
    },
    sendResetMail() {
      if(!this.$rules.integer(this.tel) || this.sending) {
        return
      }
      // this.axios.get(`/member/email/send/forget?email=${this.email}`).then(response => {
      this.axios.get(`/member/SMS/send/forget?tel=${this.tel}`).then(response => {
        if(this.step == 2) {
          this.$root.$emit('alert', 'success', '發送成功')
        }
        this.step = 2
        this.startTimer()
        this.$nextTick(() => {
          this.code = Array(6).fill('')
          this.input(0).focus()
        })
      }).catch(e => {
        if(e.response) {
          let minute = e.response.data.message.match(/Try again after (\d+) minute/)
          if(minute) {
            this.$root.$emit('alert', 'error', `請${minute[minute.length - 1]}分鐘後再試`)
          }
          else if(e.response.data.message.includes('No member')) {
            // this.$root.$emit('alert', 'error', '該Email不存在')
            this.$root.$emit('alert', 'error', '該手機號碼不存在')
          }
          else if(e.response.data.message.includes('You send too many times')) {
            this.$root.$emit('alert', 'error', '發送請求過多，請聯繫客服')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '發送失敗')
        }
      })
    },
    inputAction(i) {
      if(this.$numeric.includes(event.keyCode) && this.code.join('').length >= i) {
        this.code[i] = event.key
        if(this.code.join('').length == 6) {
          this.verifyCode()
        }
        else {
          this.input(i + 1).focus()
        }
      }
      else if(event.keyCode == 8) {
        if(this.code[i]) {
          this.code[i] = ''
        }
        else if(this.code.join('').length) {
          this.code[i - 1] = ''
          this.input(i - 1).focus()
        }
      }
      this.$forceUpdate()
      if(!this.$funcKeys.includes(event.keyCode)) {
        event.preventDefault()
      }
    },
    startTimer() {
      this.sending = true
      var timer = setInterval(() => {
        this.time -= 1 
        if(this.time < 0) {
          this.time = this.$resendTime
          clearInterval(timer)
          this.sending = false
        }
      }, 1000)
    },
    verifyCode() {
      this.axios.post('/member/SMS/verify/code', {
        code: this.code.join(''),
        tel: this.tel
      }).then(response => {
        this.step = 3
      }).catch(() => {
        this.code = Array(6).fill('')
        this.input(0).focus()
        this.$root.$emit('alert', 'error', '驗證碼錯誤')
      })
    },
    resetPassword() {
      if(this.password != this.rePassword) {
        return
      }
      this.axios.post('/member/SMS/verify/forget', {
        code: this.code.join(''),
        tel: this.tel,
        password: this.password
      }).then(response => {
        this.step = 4
        this.$store.dispatch('user/setToken', `Bearer ${response.data.token}`)
        this.$store.dispatch('user/getUserInformation').then(() => {
          if(this.all_verified) {
            this.$store.dispatch('shoppingCart/getShoppingCartProducts')
            this.$store.dispatch('user/getBans')
            this.$store.dispatch('user/getFollowList')
            this.$store.dispatch('user/getBlockList')
            this.$store.dispatch('user/getPurchaseID')
            this.$store.dispatch('user/getLikeID')
          }
        })
      }).catch(e => {
        if(e.response.data.message.includes('Code is wrong')) {
          this.$router.push('/forget/expired')
        }
        else if(e.response.data.message.includes('The token is expired')) {
          this.$router.push('/forget/expired')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.forgetPassword {
	background-color: rgba(0, 0, 0, .75);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 60px);
  .v-card {
    width: 400px;
    div {
      font-size: 14px;
    }
    a {
      color: unset !important;
      text-decoration: underline !important;
      font-size: 12px;
    }
    span {
      font-size: 12px;
    }
    .v-text-field__details {
      display: none;
    }
    .v-icon {
      margin: 20px 0;
      font-size: 70px;
    }
  }
}
</style>